
      import { authStore } from '/src/shared/stores/auth-store.ts';
      import { notificationService } from '/src/shared/services/notification-service.ts';

      let mode = 'login';

      document.addEventListener('DOMContentLoaded', async () => {
        // 入场渐显
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        document.querySelectorAll('.reveal').forEach(el => {
          if (reduceMotion) el.classList.add('in');
          else requestAnimationFrame(() => el.classList.add('in'));
        });

        await initAuth();
        initPasswordToggles();
        initTabs();

        // 通过 #register 或 ?tab=register 直接进入注册
        const wantRegister =
          window.location.hash === '#register' ||
          new URLSearchParams(window.location.search).get('tab') === 'register';
        setMode(wantRegister ? 'register' : 'login');
      });

      async function initAuth() {
        // 已登录则直接跳转
        await authStore.ensureReady();
        const currentUser = authStore.getCurrentUser();
        if (currentUser) {
          redirectAfterLogin();
          return;
        }

        const form = document.getElementById('auth-form');
        form.addEventListener('submit', async e => {
          e.preventDefault();
          if (mode === 'register') await handleRegister();
          else await handleLogin();
        });

        refreshCaptcha();
      }

      function getValues() {
        return {
          email: document.getElementById('email').value.trim(),
          password: document.getElementById('password').value,
          confirmPassword: document.getElementById('confirm_password').value,
          captcha: document.getElementById('captcha').value.trim(),
        };
      }

      async function handleLogin() {
        const { email, password, captcha } = getValues();
        const submitButton = document.getElementById('submit-btn');

        if (!email || !password || !captcha) {
          notificationService.error('请填写完整的登录信息');
          return;
        }
        if (!isValidEmail(email)) {
          notificationService.error('请输入有效的邮箱地址');
          return;
        }

        try {
          submitButton.disabled = true;
          submitButton.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>登录中...';
          notificationService.loading('正在验证登录信息...');

          await authStore.login({ email, password, captcha });
          notificationService.success('登录成功！正在跳转...');
          setTimeout(redirectAfterLogin, 1000);
        } catch (error) {
          console.error('Login error:', error);
          notificationService.error(error.message || '登录失败，请检查用户名和密码');
          refreshCaptcha();
        } finally {
          submitButton.disabled = false;
          submitButton.innerHTML = '登录';
        }
      }

      async function handleRegister() {
        const { email, password, confirmPassword, captcha } = getValues();
        const submitButton = document.getElementById('submit-btn');

        if (!email || !password || !confirmPassword || !captcha) {
          notificationService.error('请填写完整的注册信息');
          return;
        }
        if (!isValidEmail(email)) {
          notificationService.error('请输入有效的邮箱地址');
          return;
        }
        if (password !== confirmPassword) {
          notificationService.error('两次输入的密码不一致');
          return;
        }
        if (password.length < 6) {
          notificationService.error('密码长度至少为6位');
          return;
        }

        try {
          submitButton.disabled = true;
          submitButton.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>注册中...';
          notificationService.loading('正在创建账户...');

          const response = await fetch('/api/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password, code: captcha }),
          });
          const result = await response.json();

          if (result.success) {
            notificationService.success('注册成功！请使用账户登录');
            // 切换到登录模式并保留已填邮箱
            setMode('login');
            document.getElementById('password').value = '';
            refreshCaptcha();
          } else {
            throw new Error(result.message || '注册失败');
          }
        } catch (error) {
          console.error('Register error:', error);
          notificationService.error(error.message || '注册失败，请重试');
          refreshCaptcha();
        } finally {
          submitButton.disabled = false;
          submitButton.innerHTML = mode === 'register' ? '创建账户' : '登录';
        }
      }

      function redirectAfterLogin() {
        const urlParams = new URLSearchParams(window.location.search);
        const returnUrl = urlParams.get('return') || urlParams.get('next');
        if (returnUrl) {
          let finalUrl = decodeURIComponent(returnUrl);
          if (finalUrl.includes('/pages/service/inspection.html')) {
            const separator = finalUrl.includes('?') ? '&' : '?';
            finalUrl += `${separator}from=login`;
          }
          window.location.href = finalUrl;
        } else {
          window.location.href = '/pages/user/index.html';
        }
      }

      function setMode(next) {
        mode = next;
        const isRegister = next === 'register';

        document.getElementById('tabLogin').classList.toggle('active', !isRegister);
        document.getElementById('tabRegister').classList.toggle('active', isRegister);
        document.getElementById('confirmField').classList.toggle('is-open', isRegister);
        document.getElementById('authTitle').textContent = isRegister ? '创建账户' : '欢迎回来';
        document.getElementById('submit-btn').textContent = isRegister ? '创建账户' : '登录';
        document.getElementById('password').setAttribute(
          'autocomplete',
          isRegister ? 'new-password' : 'current-password'
        );
        document.getElementById('password').setAttribute(
          'placeholder',
          isRegister ? '请输入密码（至少 6 位）' : '请输入密码'
        );

        const switchHint = document.getElementById('switchHint');
        switchHint.innerHTML = isRegister
          ? '已有账户？<button id="switchToLogin" type="button" class="text-gold hover:text-gold-hover transition">立即登录</button>'
          : '还没有账户？<button id="switchToRegister" type="button" class="text-gold hover:text-gold-hover transition">立即注册</button>';
        bindSwitch();

        // 同步 URL hash，便于直达 & 刷新保持
        history.replaceState(null, '', isRegister ? '#register' : '#login');
      }

      function bindSwitch() {
        const toReg = document.getElementById('switchToRegister');
        const toLog = document.getElementById('switchToLogin');
        if (toReg) toReg.addEventListener('click', () => setMode('register'));
        if (toLog) toLog.addEventListener('click', () => setMode('login'));
      }

      function initTabs() {
        document.getElementById('tabLogin').addEventListener('click', () => setMode('login'));
        document.getElementById('tabRegister').addEventListener('click', () => setMode('register'));
        bindSwitch();
      }

      function initPasswordToggles() {
        const bind = (btnId, inputId) => {
          const btn = document.getElementById(btnId);
          const input = document.getElementById(inputId);
          btn.addEventListener('click', () => {
            const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
            input.setAttribute('type', type);
            const icon = btn.querySelector('i');
            icon.classList.toggle('fa-eye');
            icon.classList.toggle('fa-eye-slash');
          });
        };
        bind('toggle-password', 'password');
        bind('toggle-confirm-password', 'confirm_password');
      }

      function refreshCaptcha() {
        const captchaImg = document.getElementById('captcha-img');
        captchaImg.src = `/api/captcha?t=${new Date().getTime()}`;
      }

      function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      }

      window.refreshCaptcha = refreshCaptcha;
    